import { connect } from 'react-redux';
import FinanceApprovalListing from './ApprovalListing';
import { bindActionCreators } from 'redux';
import {
  fetchApprovedRejectedList
} from 'services/redux/approvals/mrfApprovals/action';

const mapStateToProps = (state) => ({
  fetchApproveRejectListForFinance: state.mrfApprovalReducer.fetchApproveRejectListForFinance
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchApprovedRejectedList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FinanceApprovalListing);
